import routes from '../routes/index.routes';
import { DomainOverlap } from '../../pages/domain-overlap/index/domain-overlap.page';

export const DomainOverlapRouter = [
	{
		path: routes.domainOverlap.index(),
		element: <DomainOverlap />,
	},
];
